import { useSearch } from "@tanstack/react-router";
import { useState } from "react";
import SignUpEmailAndPhone from "./SignUpEmailAndPhone";
import ValidateAccessCodeStep from "./ValidateAccessCodeStep";

type SignUpStep = "code" | "email_and_phone";

const SignUpWrapper = () => {
	const search = useSearch({ from: "/sign-up" });
	const [currentStep, setCurrentStep] = useState<SignUpStep>("code");
	const [promoCode, setPromoCode] = useState("");

	const handleAccessCodeValidated = (accessCode: string) => {
		setPromoCode(accessCode);
		setCurrentStep("email_and_phone");
	};

	if (currentStep === "code") {
		return (
			<ValidateAccessCodeStep
				initialCode={search?.promo}
				onValidated={handleAccessCodeValidated}
			/>
		);
	}

	return <SignUpEmailAndPhone promo_code={promoCode} />;
};

export default SignUpWrapper;
